module.exports = __webpack_public_path__ + "media/images/multi-arrow-up-366efa728df4369874f0251982c6c302.svg";